common.View.create('canvas.blocks.custom.logoSlider.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {

        let options = {
            loop: this.element.find('.owl-carousel').children().length > 1,
            margin: 20,
            autoplay: this.element.find('.owl-carousel').data('autoplay'),
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoplayTimeout: 3000,
            autoplaySpeed: 3000,
            slideTransition: 'linear',
            lazyLoad: false,
            responsive: {
                0: {
                    items: 1
                },
                640: {
                    items: 3
                },
                1000: {
                    items: 5
                }
            }
        };

        this.element.find('.owl-carousel').owlCarousel(options);

        $('.owl-item .canvas\\:\\:canvas-blocks-utils-image-Image').removeAttr('loading');
    }
});
